import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CostPlansPage } from '@/features/commercial/cost-plans-page';

const searchSchema = z.object({
  plan: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/cost-plans')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <CostPlansPage projectId={projectId} plan={search.plan} />;
}
